exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoticeModal_8XiBwK5{text-align:center}.NoticeModal_8XiBwK5 .NoticeModal1T9rGtZQ{position:relative}.NoticeModal1SEIX4hr,.NoticeModal11RNukIO{position:absolute}\n", ""]);

// exports
exports.locals = {
	"mainid": "NoticeModal_8XiBwK5",
	"button": "NoticeModal1T9rGtZQ",
	"top": "NoticeModal1SEIX4hr",
	"bottom": "NoticeModal11RNukIO"
};